import AuthLayout from '../../../components/AuthLayout';
import GoogleRegisterContainer from '../../../containers/GoogleRegister';

export default function Register() {
  return (
    <AuthLayout maxWidth="xl" title="رابکس | تکمیل ثبت‌نام">
      <GoogleRegisterContainer />
    </AuthLayout>
  );
}
